<section class="benachrichtigungen" [attr.aria-labelledby]="titelId">
  <div class="benachrichtigungen__kopf">
    <div class="benachrichtigungen__titel">
      <to-section-title
        [headingId]="titelId"
        [title]="'account.benachrichtigungen.titel' | translate"
        [subtitle]="'account.benachrichtigungen.untertitel' | translate"
      />
    </div>
    @if (gespeichert()) {
      <span role="status" class="benachrichtigungen__pille">
        <mat-icon class="benachrichtigungen__pille-icon" aria-hidden="true">check</mat-icon>
        {{ 'account.benachrichtigungen.gespeichert' | translate }}
      </span>
    }
    <div class="benachrichtigungen__alle">
      <span class="benachrichtigungen__alle-label">{{ 'account.benachrichtigungen.alleAuf' | translate }}</span>
      @for (kanal of kanaele; track kanal) {
        <button
          type="button"
          class="benachrichtigungen__knopf"
          [attr.data-testid]="'alle-auf-' + kanal"
          [disabled]="!bedienbar()"
          (click)="alleAuf(kanal)"
        >
          {{ 'account.benachrichtigungen.kanal.' + kanal | translate }}
        </button>
      }
    </div>
  </div>

  @if (ladefehler()) {
    <div class="benachrichtigungen__ladefehler" data-testid="benachrichtigungen-ladefehler">
      <p class="benachrichtigungen__ladefehler-text">{{ 'account.benachrichtigungen.ladefehler' | translate }}</p>
      <button type="button" class="benachrichtigungen__knopf" data-testid="benachrichtigungen-erneut" (click)="laden()">
        {{ 'account.benachrichtigungen.erneutVersuchen' | translate }}
      </button>
    </div>
  } @else {
    <div class="benachrichtigungen__tabelle">
      <div class="benachrichtigungen__kopfzeile">
        <div class="benachrichtigungen__spalte-meldung">
          {{ 'account.benachrichtigungen.spalteMeldung' | translate }}
        </div>
        <div class="benachrichtigungen__spalte-kanal">{{ 'account.benachrichtigungen.spalteKanal' | translate }}</div>
      </div>
      @for (art of arten; track art) {
        <div class="benachrichtigungen__zeile" [attr.data-testid]="'benachrichtigung-' + art">
          <div class="benachrichtigungen__meldung">
            <div class="benachrichtigungen__name">
              {{ 'account.benachrichtigungen.arten.' + art + '.label' | translate }}
            </div>
            <div class="benachrichtigungen__beschreibung">
              {{ 'account.benachrichtigungen.arten.' + art + '.beschreibung' | translate }}
            </div>
          </div>
          <app-segmented-filter-control
            class="benachrichtigungen__kanal"
            density="kanal"
            [items]="kanalItems()"
            [value]="stand()?.[art] ?? null"
            [disabled]="!bedienbar()"
            [ariaLabel]="'account.benachrichtigungen.arten.' + art + '.label' | translate"
            (valueChange)="waehle(art, $event)"
          />
        </div>
      }
    </div>

    <p class="benachrichtigungen__legende">
      <strong>{{ 'account.benachrichtigungen.kanal.dashboard' | translate }}</strong>
      {{ 'account.benachrichtigungen.legende.dashboard' | translate }} ·
      <strong>{{ 'account.benachrichtigungen.kanal.mail' | translate }}</strong>
      {{ 'account.benachrichtigungen.legende.mail' | translate }} ·
      <strong>{{ 'account.benachrichtigungen.kanal.beides' | translate }}</strong>
      {{ 'account.benachrichtigungen.legende.beides' | translate }} ·
      {{ 'account.benachrichtigungen.legende.postfach' | translate }}
    </p>
  }
</section>
